import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Select from "react-select";

import { Astrolger_Profile_Update, get_astro_profile } from '../../../../api/astrologer/Astrologer';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { toast } from 'react-toastify'

import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL } from '../../../../config/Config';
import Astrologer_after_Login_Header from '../astrologer_after_login_header/Astrologer_after_Login_Header';
import { isValidFacebookLink, isValidFullName, isValidInstagramLink, isValidLinkedInLink, isValidWebsite, isValidYouTubeLink } from '../../../validation/Validation';

const Astrologer_Save_Profile_Update = () => {
    const navigate = useNavigate();
    const [userLocation, setLocation] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [astro_step_active_form, set_Astro_Active_Form] = useState("0");
    const [profileImg, setProfileImg] = useState([]);
    const [user_role, setUserRole] = useState(null);
    const [skills, set_Skills] = useState([])
    const [language, set_Language] = useState([])
    const [pooja_Categories, set_Pooja_Categories] = useState([])


    // <-------- astro update form -------->
    const [astrologer_update_profile_form, set_Astrologer_Update_Profile_Form] = useState({
        name: "",
        dob: "",
        birth_place: "",
        faith: "",
        address: "",
        country: "",
        state: "",
        city: "",
        experience: "",
        gender: "",
        highest_qualification: "",
        degree: "",
        collage_school: "",
        from_astroogy: "",
        // hourly_rate: "",
        // minute_rate: "",
        chat_rate: "",
        audio_call_rate: "",
        emergency_audio_call_rate: "",
        emergency_video_call_rate: "",
        video_call_rate: "",
        instagram: "",
        facebook: "",
        linked_in: "",
        youtube: "",
        website: "",
        about_us: "",
        about_us: "",
        profileImg: [],
        skills: [],
        language: [],
        poojacategorie: [],

    })

    useEffect(() => {

        const getLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLocation({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                        //   fetchAstrologers(position.coords.latitude, position.coords.longitude);
                    },
                    (err) => setError(err.message)
                );
            } else {
                setError("Geolocation is not supported by this browser.");
            }
        };
        getLocation();
    }, []);

    const handle_profile_form_update = (e, fieldName) => {

        if (e.target && e.target.type === "file") {
            const file = e.target.files[0];
            if (file) {
                const validTypes = ["image/jpeg", "image/png", "image/jpg"];
                const maxSize = 5 * 1024 * 1024; // 5 MB

                if (!validTypes.includes(file.type)) {
                    toast("Invalid file type. Please upload a JPEG or PNG image.");
                    return;
                }

                if (file.size > maxSize) {
                    toast("File size exceeds 5 MB. Please upload a smaller image.");
                    return;
                }

                const previewUrl = URL.createObjectURL(file);
                set_Astrologer_Update_Profile_Form({
                    ...astrologer_update_profile_form,
                    [fieldName]: file,
                    profileImgPreview: previewUrl,
                });
            }
        } else if (Array.isArray(e)) {
            set_Astrologer_Update_Profile_Form({
                ...astrologer_update_profile_form,
                [fieldName]: e,
            });
        } else if (e.target && e.target.name && e.target.value !== undefined) {
            const { name, value } = e.target;
            set_Astrologer_Update_Profile_Form({
                ...astrologer_update_profile_form,
                [name]: value,
            });
        }
    };

    // <-------- Handle Astro Update Profile --------->
    const handle_change_astro_profile_update = (e) => {
        const { name, value } = e.target;
        if (name === "dob") {
            const year = value.split("-")[0];
            if (year.length > 4) return; // Block input with more than 4 digit year
        }

        if (name === "name") {
            const onlyLettersAndSpaces = /^[A-Za-z ]{0,50}$/;
            if (!onlyLettersAndSpaces.test(value)) {
                return;
            }
        }

        set_Astrologer_Update_Profile_Form(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // <----- Handle Submit the Astro Bascis Details ------->
    const handle_submit_astro_update_basics_details = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const normalizedName = astrologer_update_profile_form?.name?.trim() || "";

        // Validation checks for required fields
        if (!normalizedName || !isValidFullName(normalizedName)) {
            toast("Please enter a valid full name (letters and single spaces only).");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.dob) {
            toast("Please enter your date of birth");

            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.birth_place) {
            toast("Please enter your birth place");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.faith) {
            toast("Please enter your faith");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.address) {
            toast("Please enter your address");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.country) {
            toast("Please enter your country");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.state) {
            toast("Please enter your state");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.city) {
            toast("Please enter your city");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.experience) {
            toast("Please enter your experience");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.gender) {
            toast("Please select your gender");
            setIsLoading(false);
            return;
        }
        if (astrologer_update_profile_form?.skills?.length === 0) {
            toast("At least one skill is required.");
            setIsLoading(false)
            return;
        }
        if (astrologer_update_profile_form?.language?.length === 0) {
            toast("At least one language is required.");
            setIsLoading(false)
            return;
        }
        if (user_role == 3) {
            if (astrologer_update_profile_form?.poojacategorie?.length === 0) {
                toast("At least one Pooja category is required.");
                setIsLoading(false)
                return;
            }
        }

        if (!astrologer_update_profile_form?.highest_qualification) {
            toast("Please enter your highest qualification");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.degree) {
            toast("Please enter your highest degree");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.collage_school) {
            toast("Please enter your collage/school name");
            setIsLoading(false);
            return;
        }
        if (!astrologer_update_profile_form?.from_astroogy) {
            toast("Please enter from where did you learn astrology");
            setIsLoading(false);
            return;
        }
        const formData = new FormData();
        formData.append('name', normalizedName);
        formData.append('dob', astrologer_update_profile_form?.dob);
        formData.append('birth_place', astrologer_update_profile_form?.birth_place);
        formData.append('faith', astrologer_update_profile_form?.faith);
        formData.append('address', astrologer_update_profile_form?.address);
        formData.append('country', astrologer_update_profile_form?.country);
        formData.append('state', astrologer_update_profile_form?.state);
        formData.append('city', astrologer_update_profile_form?.city);
        formData.append('gender', astrologer_update_profile_form?.gender);
        formData.append('experience', astrologer_update_profile_form?.experience);
        formData.append('highest_qualification', astrologer_update_profile_form?.highest_qualification);
        formData.append('from_astroogy', astrologer_update_profile_form?.from_astroogy);
        formData.append('collage_school', astrologer_update_profile_form?.collage_school);
        formData.append('degree', astrologer_update_profile_form?.degree);
        formData.append('latitude', userLocation?.lat || "");
        formData.append('longitude', userLocation?.lng || "");

        const languageValues = astrologer_update_profile_form?.language?.map(item => item.value).join(',');
        const skillsValues = astrologer_update_profile_form?.skills?.map(item => item.value).join(',');
        const categoryValues = astrologer_update_profile_form?.poojacategorie?.map(item => item.title).join(',');

        formData.append('language', languageValues);
        formData.append('skills', skillsValues);
        formData.append('pooja', categoryValues);

        try {
            const token = User_Authentication();
            if (!token) {
                alert("User token not found");
                setIsLoading(false);
                throw new Error("User token not found");
            }
            const response = await Astrolger_Profile_Update(formData, { Authorization: `Bearer ${token}` });

            if (response?.data?.status === true) {
                set_Astro_Active_Form("1");
                setIsLoading(false);
                const res = await get_astro_profile({ Authorization: `Bearer ${token}` });
                if (res?.data?.status === true) {
                    const astro_data = res?.data?.data || {};
                    const astroDetail = res?.data?.data?.astrodetail || {};
                    const astro_amounts = res?.data?.data?.astro_amounts || {};
                    set_Astrologer_Update_Profile_Form({
                        name: astro_data?.name,
                        dob: astroDetail?.dob ? astroDetail.dob.split(' ')[0] : '',
                        birth_place: astroDetail?.birth_place || "",
                        faith: astroDetail?.faith || "",
                        address: astroDetail?.address || "",
                        country: astroDetail?.country || "",
                        state: astroDetail?.state || "",
                        city: astroDetail?.city || "",
                        highest_qualification: astroDetail?.
                            highest_qualification || "",
                        degree: astroDetail?.degree
                            || "",
                        collage_school: astroDetail?.collage_school || "",
                        from_astroogy: astroDetail?.from_astroogy
                            || "",
                        audio_call_rate: astro_amounts?.audio_call_rate || "",
                        video_call_rate: astro_amounts?.video_call_rate || "",
                        chat_rate: astro_amounts?.chat_rate || "",
                        emergency_audio_call_rate: astro_amounts?.emergency_audio_call_rate || "",
                        emergency_video_call_rate: astro_amounts?.emergency_video_call_rate || "",
                        youtube: astroDetail?.youtube || "",
                        linked_in: astroDetail?.linked_in || "",
                        website: astroDetail?.website || "",
                        facebook: astroDetail?.facebook || "",
                        instagram: astroDetail?.instagram || "",
                        about_us: astroDetail?.about_us || "",
                    });
                    const profileImages = Array.isArray(response?.data?.data?.profile_images) ? response?.data?.data?.profile_images : [];
                    const baseUrl = `${IMG_BASE_URL}`;
                    const formattedProfileImages = profileImages?.map((img) => ({
                        url: baseUrl + img.image_file,
                        file: null,
                    }));
                    setProfileImg(formattedProfileImages);
                }

                // set_Astrologer_Update_Profile_Form(response?.data?.data);
            }
            else if (response?.response?.data?.status == false) {
                setIsLoading(false)
                toast(response?.response?.data?.message)
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error during submission:", error);
        }
    };


    // <----- Handle Submit the Add Gallery Details ------->
    const handle_submit_astro_Price_details = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        if (!astrologer_update_profile_form?.chat_rate) {
            toast("Please enter your chat rate");
            setIsLoading(false)
            return;
        }
        if (!astrologer_update_profile_form?.audio_call_rate) {
            toast("Please enter your audio call rate");
            setIsLoading(false)
            return;
        }
        if (!astrologer_update_profile_form?.video_call_rate) {
            toast("Please enter your video call rate");
            setIsLoading(false)
            return;
        }
        if (!astrologer_update_profile_form?.emergency_audio_call_rate) {
            toast("Please enter your emergency audio call rate");
            setIsLoading(false)
            return;
        }
        if (!astrologer_update_profile_form?.emergency_video_call_rate) {
            toast("Please enter your emergency video call rate");
            setIsLoading(false)
            return;
        }

        // if (!astrologer_update_profile_form?.instagram) {
        //     toast("Please enter a valid Instagram profile URL.");
        //     setIsLoading(false)
        //     return;
        // }
        // if (!astrologer_update_profile_form?.facebook) {
        //     toast("Please enter a valid facebook profile URL.");
        //     setIsLoading(false)
        //     return;
        // }
        // if (!astrologer_update_profile_form?.linked_in) {
        //     toast("Please enter a valid linkedIn profile URL.");
        //     setIsLoading(false)
        //     return;
        // }
        // if (!astrologer_update_profile_form?.youtube) {
        //     toast("Please enter a valid youtube profile URL.");
        //     setIsLoading(false)
        //     return;
        // }
        // if (!astrologer_update_profile_form?.website) {
        //     toast("Please enter a valid website URL.");
        //     setIsLoading(false)
        //     return;
        // }
        if (!astrologer_update_profile_form?.about_us) {
            toast("Please enter about to astrologer");
            setIsLoading(false)
            return;
        }

        const formData = new FormData();
        // formData.append('hourly_rate', astrologer_update_profile_form?.hourly_rate);
        // formData.append('minute_rate', astrologer_update_profile_form?.minute_rate);
        formData.append('video_call_rate', astrologer_update_profile_form?.video_call_rate);
        formData.append('emergency_video_call_rate', astrologer_update_profile_form?.emergency_video_call_rate);
        formData.append('emergency_audio_call_rate', astrologer_update_profile_form?.emergency_audio_call_rate);
        formData.append('audio_call_rate', astrologer_update_profile_form?.audio_call_rate);
        formData.append('chat_rate', astrologer_update_profile_form?.chat_rate);
        formData.append('instagram', astrologer_update_profile_form?.instagram);
        formData.append('facebook', astrologer_update_profile_form?.facebook);
        formData.append('linked_in', astrologer_update_profile_form?.linked_in);
        formData.append('youtube', astrologer_update_profile_form?.youtube);
        formData.append('website', astrologer_update_profile_form?.website);
        formData.append('about_us', astrologer_update_profile_form?.about_us);
        try {
            const token = User_Authentication();
            if (!token) {
                alert("User token not found");
                setIsLoading(false)
                throw new Error("User token not found");
            }
            const response = await Astrolger_Profile_Update(formData, { Authorization: `Bearer ${token}` });
            if (response?.data?.status == true) {
                set_Astro_Active_Form("2");
                setIsLoading(false)
                set_Astrologer_Update_Profile_Form(response?.data?.data)
            }
            else if (response?.response?.data?.status == false) {
                setIsLoading(false)
                toast(response?.response?.data?.message)
            }
        } catch (error) {
            setIsLoading(false)
            console.error("Error during submission:", error);
        }
    };
    // <----- Handle Submit the Astro Bascis Details ------->
    const handle_submit_Add_Gallery_details = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (profileImg.length === 0) {
            setIsLoading(false);
            toast("Please add at least one image before submitting!");
            return;
        }

        const formData = new FormData();
        profileImg.forEach((img, index) => {

            if (img.file) {
                formData.append(`profileImg[${index}]`, img.file);
            }
        });

        try {
            const token = User_Authentication();
            if (!token) {
                alert("User token not found");
                setIsLoading(false);
                throw new Error("User token not found");
            }

            const response = await Astrolger_Profile_Update(formData, { Authorization: `Bearer ${token}` });

            if (response?.data?.status === true) {
                setIsLoading(false);
                set_Astrologer_Update_Profile_Form(response?.data?.data);
                if (user_role == 2) {
                    navigate("/astrologer-save-profile");
                }
                if (user_role == 3) {
                    navigate("/pandit-save-profile");
                }
            }
            if (response?.response?.status == 400) {
                toast(response?.response?.data?.message)
                setIsLoading(false);
                if (user_role == 2) {
                    navigate("/astrologer-save-profile-update");
                }
                if (user_role == 3) {
                    navigate("/pandit-save-profile-update");
                }
            }
            else if (response?.response?.data?.status === false) {
                setIsLoading(false);
                toast(response?.response?.data?.message);
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error during submission:", error);
        }
    };


    // <---------- Get Astro Update Profile -------->
    useEffect(() => {
        const Handle_get_astro_update_profile = async () => {
            setIsLoading(true);
            try {
                const token = User_Authentication();
                if (!token) {
                    alert("User token not found");
                    setIsLoading(false);
                    return;
                }
                const response = await get_astro_profile({ Authorization: `Bearer ${token}` });
                if (response?.data?.status === true) {
                    const astro_data = response?.data?.data || {};
                    const astroDetail = response?.data?.data?.astrodetail || {};
                    const astro_amounts = response?.data?.data?.astro_amounts || {};
                    setUserRole(astro_data?.user_role)
                    const skills = response?.data?.skills || []
                    const languages = response?.data?.languages || []
                    const pooja_Category = response?.data?.pooja_category || []

                    const formattedSkills = skills?.map(skill => ({
                        value: skill.skill,  // Assuming skills have an 'id' field
                        label: skill.skill // Assuming skills have a 'name' field
                    }));
                    const formattedlanguages = languages?.map(language => ({
                        value: language?.language,  // Assuming skills have an 'id' field
                        label: language?.language // Assuming skills have a 'name' field
                    }));

                    // const formattedpoojacategorie = pooja_Category?.map(category => ({
                    //     value: language?.language,  // Assuming skills have an 'id' field
                    //     label: language?.language // Assuming skills have a 'name' field
                    // }));

                    set_Skills(formattedSkills)
                    set_Language(formattedlanguages)
                    set_Pooja_Categories(pooja_Category)
                    const userSkills = astro_data?.skills;
                    const skillsArray = userSkills.split(",");
                    const userLanguages = astro_data?.language;
                    const languagesArray = userLanguages.split(",");
                    const poojaCategoriesArray = astro_data?.pooja?.split(",");
                    const matchedSkills = Array.from(
                        new Map(
                            formattedSkills
                                ?.filter(opt => skillsArray.includes(opt.value))
                                .map(item => [item.value, item])
                        ).values()
                    );


                    // const matchedLanguages = formattedlanguages?.filter(opt =>
                    //     languagesArray.includes(opt.value)
                    // );

                    const matchedLanguages = Array.from(
                        new Map(
                            formattedlanguages
                                ?.filter(opt => languagesArray.includes(opt.value))
                                .map(item => [item.value, item])
                        ).values()
                    );

                    // const matchedPoojacategory = pooja_Category?.filter(opt =>
                    //     poojaCategoriesArray.includes(opt.title)
                    // );

                    const matchedPoojacategory = Array.from(
                        new Map(
                            pooja_Category
                                ?.filter(opt => poojaCategoriesArray.includes(opt.title))
                                .map(item => [item.title, item])
                        ).values()
                    );

                    set_Astrologer_Update_Profile_Form({
                        name: astro_data?.name,
                        dob: astroDetail?.dob ? astroDetail.dob.split(' ')[0] : '',
                        birth_place: astroDetail?.birth_place || "",
                        faith: astroDetail?.faith || "",
                        address: astroDetail?.address || "",
                        country: astroDetail?.country || "",
                        state: astroDetail?.state || "",
                        city: astroDetail?.city || "",
                        experience: astro_data?.experience || "",
                        gender: astro_data?.gender || "",
                        highest_qualification: astroDetail?.
                            highest_qualification || "",
                        degree: astroDetail?.degree
                            || "",
                        collage_school: astroDetail?.collage_school || "",
                        from_astroogy: astroDetail?.from_astroogy
                            || "",
                        audio_call_rate: astro_amounts?.audio_call_rate || "",
                        video_call_rate: astro_amounts?.video_call_rate || "",
                        chat_rate: astro_amounts?.chat_rate || "",
                        emergency_audio_call_rate: astro_amounts?.emergency_audio_call_rate || "",
                        emergency_video_call_rate: astro_amounts?.emergency_video_call_rate || "",
                        youtube: astroDetail?.youtube || "",
                        linked_in: astroDetail?.linked_in || "",
                        website: astroDetail?.website || "",
                        facebook: astroDetail?.facebook || "",
                        instagram: astroDetail?.instagram || "",
                        about_us: astroDetail?.about_us || "",
                        skills: matchedSkills || [],
                        language: matchedLanguages || [],
                        poojacategorie: matchedPoojacategory || [],

                    });
                    const profileImages = Array.isArray(response?.data?.data?.profile_images) ? response?.data?.data?.profile_images : [];
                    const baseUrl = `${IMG_BASE_URL}`;
                    const formattedProfileImages = profileImages?.map((img) => ({
                        url: baseUrl + img.image_file,
                        file: null,
                    }));
                    setProfileImg(formattedProfileImages);



                }
                // if (response?.data?.data?.profile_step == "1") {
                //     set_Astro_Active_Form("1");
                //     localStorage.setItem("profile_step", 1);
                // } else if (response?.data?.data?.profile_step == "2") {
                //     set_Astro_Active_Form("2");
                //     localStorage.setItem("profile_step", 2);
                // } else if (response?.data?.data?.profile_step == "3") {
                //     localStorage.setItem("astro_is_active", true);
                // }
            } catch (error) {
                console.error("Error fetching profile:", error);
            } finally {
                setIsLoading(false);
            }
        };
        Handle_get_astro_update_profile();
    }, [astro_step_active_form]);

    // Handle file selection
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setProfileImg((prevImages) => [...prevImages, ...newImages]);
    };

    const handleRemoveImage = (indexToRemove) => {
        setProfileImg((prevImages) => {
            const updatedImages = prevImages.filter((_, index) => index !== indexToRemove);
            return updatedImages;
        });
    };




    localStorage.setItem("astrologer_update_profile_form_dob", astrologer_update_profile_form?.dob)

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            {/*  */}
            <Astrologer_after_Login_Header />
            {/* <-------- ToastContainer ------------> */}
            {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
            {
                isLoading ? (
                    <Loader />
                ) : (
                    <section className="bg-[#f8f9fa] py-8 px-4 sm:px-6 lg:px-8 pt-24 lg:pt-10">
                        <div className="max-w-[1200px] mx-auto pb-5">
                            <div className="flex flex-col md:flex-row gap-6 items-start">
                                {/* Left Stepper Sidebar */}
                                <div className="w-full md:w-[30%] bg-white border border-gray-100 rounded-2xl p-4 sm:p-5 shadow-sm">
                                    <div className="flex md:flex-col gap-3 md:gap-4 overflow-x-auto pb-4 md:pb-0 scrollbar-none">
                                        <button
                                            onClick={() => set_Astro_Active_Form("0")}
                                            className={`flex items-center gap-3 w-full min-w-[200px] text-left p-3.5 rounded-xl border transition-all duration-200 ${astro_step_active_form === "0"
                                                    ? "border-[#9F2225] bg-[#9F2225]/5 text-[#9F2225]"
                                                    : "border-gray-100 hover:bg-gray-50 text-gray-500"
                                                }`}
                                            type="button"
                                        >
                                            <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-200 ${astro_step_active_form === "0" ? "bg-[#9F2225] text-white" : "bg-gray-100 text-gray-400"
                                                }`}>1</span>
                                            <div>
                                                <div className="font-bold text-xs">Step 1</div>
                                                <div className="text-xs font-semibold text-gray-500">Basic Details</div>
                                            </div>
                                        </button>

                                        <button
                                            onClick={() => set_Astro_Active_Form("1")}
                                            className={`flex items-center gap-3 w-full min-w-[200px] text-left p-3.5 rounded-xl border transition-all duration-200 ${astro_step_active_form === "1"
                                                    ? "border-[#9F2225] bg-[#9F2225]/5 text-[#9F2225]"
                                                    : "border-gray-100 hover:bg-gray-50 text-gray-500"
                                                }`}
                                            type="button"
                                        >
                                            <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-200 ${astro_step_active_form === "1" ? "bg-[#9F2225] text-white" : "bg-gray-100 text-gray-400"
                                                }`}>2</span>
                                            <div>
                                                <div className="font-bold text-xs">Step 2</div>
                                                <div className="text-xs font-semibold text-gray-500">Rates & Socials</div>
                                            </div>
                                        </button>

                                        <button
                                            onClick={() => set_Astro_Active_Form("2")}
                                            className={`flex items-center gap-3 w-full min-w-[200px] text-left p-3.5 rounded-xl border transition-all duration-200 ${astro_step_active_form === "2"
                                                    ? "border-[#9F2225] bg-[#9F2225]/5 text-[#9F2225]"
                                                    : "border-gray-100 hover:bg-gray-50 text-gray-500"
                                                }`}
                                            type="button"
                                        >
                                            <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-200 ${astro_step_active_form === "2" ? "bg-[#9F2225] text-white" : "bg-gray-100 text-gray-400"
                                                }`}>3</span>
                                            <div>
                                                <div className="font-bold text-xs">Step 3</div>
                                                <div className="text-xs font-semibold text-gray-500">Gallery Upload</div>
                                            </div>
                                        </button>
                                    </div>
                                </div>

                                {/* Right Form Panels */}
                                <div className="w-full md:w-[70%] bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 lg:p-8 shadow-sm">
                                    <div className="multisteps-form__form">

                                        {/* STEP 0: BASIC DETAILS */}
                                        {astro_step_active_form === "0" && (
                                            <div>
                                                <h3 className="text-lg font-bold text-gray-800 tracking-tight mb-5 pb-2 border-b border-gray-100">Basic Details</h3>
                                                <form method="post" onSubmit={handle_submit_astro_update_basics_details}>
                                                    <div className="space-y-4">
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Name</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="Name" name="name" value={astrologer_update_profile_form?.name} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" pattern="[A-Za-z]+( [A-Za-z]+)*" title="Please enter letters and single spaces only." maxLength={50} required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Date of birth</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="Date of birth" name="dob" value={astrologer_update_profile_form?.dob} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="date" required />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Place of Birth</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="Place of Birth" name="birth_place" value={astrologer_update_profile_form?.birth_place} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Faith</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="Faith" name="faith" value={astrologer_update_profile_form?.faith} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Current Address</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="address" value={astrologer_update_profile_form?.address} onChange={handle_change_astro_profile_update} placeholder="Enter flat, house no, Building" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Country</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="country" value={astrologer_update_profile_form?.country} onChange={handle_change_astro_profile_update} placeholder="Country" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">State</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="state" value={astrologer_update_profile_form?.state} onChange={handle_change_astro_profile_update} placeholder="State" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">City</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="city" value={astrologer_update_profile_form?.city} onChange={handle_change_astro_profile_update} placeholder="Enter Town/City" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Experience (in years)</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input type="number" min="0" max="50" name="experience" placeholder="Enter experience" value={astrologer_update_profile_form?.experience} onChange={handle_profile_form_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Gender</label>
                                                                <div className="grid grid-cols-3 gap-2.5">
                                                                    <div className="relative">
                                                                        <input type="radio" id="male" value="male" checked={astrologer_update_profile_form?.gender === "male"} name="gender" onChange={handle_profile_form_update} className="sr-only peer" />
                                                                        <label htmlFor="male" className="m-0 flex items-center justify-center w-full px-2 h-12 font-bold text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-[#9F2225] peer-checked:bg-[#9F2225]/5 peer-checked:text-[#9F2225] hover:bg-gray-50 transition-all duration-200 text-[13px] text-center">Male</label>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <input type="radio" id="female" value="female" checked={astrologer_update_profile_form?.gender === "female"} name="gender" onChange={handle_profile_form_update} className="sr-only peer" />
                                                                        <label htmlFor="female" className="m-0 flex items-center justify-center w-full px-2 h-12 font-bold text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-[#9F2225] peer-checked:bg-[#9F2225]/5 peer-checked:text-[#9F2225] hover:bg-gray-50 transition-all duration-200 text-[13px] text-center">Female</label>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <input type="radio" id="other" value="other" checked={astrologer_update_profile_form?.gender === "other"} name="gender" onChange={handle_profile_form_update} className="sr-only peer" />
                                                                        <label htmlFor="other" className="m-0 flex items-center justify-center w-full px-2 h-12 font-bold text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-[#9F2225] peer-checked:bg-[#9F2225]/5 peer-checked:text-[#9F2225] hover:bg-gray-50 transition-all duration-200 text-[13px] text-center">Other</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="pt-2">
                                                            <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Skills</label>
                                                            <Select
                                                                options={skills}
                                                                isMulti
                                                                name="skills"
                                                                value={astrologer_update_profile_form.skills}
                                                                onChange={(selected) => handle_profile_form_update(selected, "skills")}
                                                                getOptionLabel={(option) => option.label}
                                                                getOptionValue={(option) => option.value}
                                                                placeholder="Select skills..."
                                                                className="react-select-container text-sm font-semibold text-gray-700 bg-white"
                                                                classNamePrefix="react-select"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        border: "1px solid #e5e7eb",
                                                                        borderRadius: "0.75rem",
                                                                        padding: "2px",
                                                                        boxShadow: state.isFocused ? "0 0 0 1px #9F2225" : "none",
                                                                        borderColor: state.isFocused ? "#9F2225" : "#e5e7eb",
                                                                        "&:hover": { borderColor: "#9F2225" }
                                                                    }),
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Languages</label>
                                                            <Select
                                                                options={language}
                                                                isMulti
                                                                name="language"
                                                                value={astrologer_update_profile_form.language}
                                                                onChange={(selected) => handle_profile_form_update(selected, "language")}
                                                                getOptionLabel={(option) => option.label}
                                                                getOptionValue={(option) => option.value}
                                                                placeholder="Select languages..."
                                                                className="react-select-container text-sm font-semibold text-gray-700 bg-white"
                                                                classNamePrefix="react-select"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        border: "1px solid #e5e7eb",
                                                                        borderRadius: "0.75rem",
                                                                        padding: "2px",
                                                                        boxShadow: state.isFocused ? "0 0 0 1px #9F2225" : "none",
                                                                        borderColor: state.isFocused ? "#9F2225" : "#e5e7eb",
                                                                        "&:hover": { borderColor: "#9F2225" }
                                                                    }),
                                                                }}
                                                            />
                                                        </div>

                                                        {user_role === 3 && (
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Pooja Category</label>
                                                                <Select
                                                                    options={pooja_Categories}
                                                                    isMulti
                                                                    name="poojacategorie"
                                                                    value={astrologer_update_profile_form.poojacategorie}
                                                                    onChange={(selected) => handle_profile_form_update(selected, "poojacategorie")}
                                                                    getOptionLabel={(option) => option.title}
                                                                    getOptionValue={(option) => option.id}
                                                                    placeholder="Select pooja categories..."
                                                                    className="react-select-container text-sm font-semibold text-gray-700 bg-white"
                                                                    classNamePrefix="react-select"
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            border: "1px solid #e5e7eb",
                                                                            borderRadius: "0.75rem",
                                                                            padding: "2px",
                                                                            boxShadow: state.isFocused ? "0 0 0 1px #9F2225" : "none",
                                                                            borderColor: state.isFocused ? "#9F2225" : "#e5e7eb",
                                                                            "&:hover": { borderColor: "#9F2225" }
                                                                        }),
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                        <h3 className="text-lg font-bold text-gray-800 tracking-tight pt-4 pb-2 border-b border-gray-100">Qualification</h3>
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Highest qualification</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="highest_qualification" value={astrologer_update_profile_form?.highest_qualification} onChange={handle_change_astro_profile_update} placeholder="E.g., Master of Arts" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Degree/Diploma</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="degree" value={astrologer_update_profile_form?.degree} onChange={handle_change_astro_profile_update} placeholder="E.g., Astrology Diploma" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">College/School/University</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="collage_school" value={astrologer_update_profile_form?.collage_school} onChange={handle_change_astro_profile_update} placeholder="E.g., Delhi University" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Where did you learn Astrology?</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input name="from_astroogy" value={astrologer_update_profile_form?.from_astroogy} onChange={handle_change_astro_profile_update} placeholder="E.g., Gurukul" className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" required />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-end w-full mt-6 pt-4 border-t border-gray-100">
                                                        <button className="bg-[#9F2225] hover:bg-[#851c1e] text-white text-xs font-bold py-2.5 px-6 rounded-xl shadow-sm transition-all duration-200" type="submit">Next</button>
                                                    </div>
                                                </form>
                                            </div>
                                        )}

                                        {/* STEP 1: PRICE RATES & SOCIALS */}
                                        {astro_step_active_form === "1" && (
                                            <div>
                                                <h3 className="text-lg font-bold text-gray-800 tracking-tight mb-5 pb-2 border-b border-gray-100">Rates & Social Links</h3>
                                                <form method="post" onSubmit={handle_submit_astro_Price_details}>
                                                    <div className="space-y-4">
                                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Chat Rate</label>
                                                                <div className="border border-gray-200 rounded-xl bg-white flex items-center overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="15" name="chat_rate" value={astrologer_update_profile_form?.chat_rate} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="number" required />
                                                                    <span className="text-xs text-gray-400 font-bold px-3 border-l border-gray-100 flex-shrink-0">/ min</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Audio Call Rate</label>
                                                                <div className="border border-gray-200 rounded-xl bg-white flex items-center overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="15" name="audio_call_rate" value={astrologer_update_profile_form?.audio_call_rate} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="number" required />
                                                                    <span className="text-xs text-gray-400 font-bold px-3 border-l border-gray-100 flex-shrink-0">/ min</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Video Call Rate</label>
                                                                <div className="border border-gray-200 rounded-xl bg-white flex items-center overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="15" name="video_call_rate" value={astrologer_update_profile_form?.video_call_rate} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="number" required />
                                                                    <span className="text-xs text-gray-400 font-bold px-3 border-l border-gray-100 flex-shrink-0">/ min</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Emergency Audio Rate</label>
                                                                <div className="border border-gray-200 rounded-xl bg-white flex items-center overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="15" name="emergency_audio_call_rate" value={astrologer_update_profile_form?.emergency_audio_call_rate} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="number" required />
                                                                    <span className="text-xs text-gray-400 font-bold px-3 border-l border-gray-100 flex-shrink-0">/ min</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Emergency Video Rate</label>
                                                                <div className="border border-gray-200 rounded-xl bg-white flex items-center overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="15" name="emergency_video_call_rate" value={astrologer_update_profile_form?.emergency_video_call_rate} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="number" required />
                                                                    <span className="text-xs text-gray-400 font-bold px-3 border-l border-gray-100 flex-shrink-0">/ min</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <h3 className="text-lg font-bold text-gray-800 tracking-tight pt-4 pb-2 border-b border-gray-100">Social Media Links</h3>
                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Instagram Link</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="https://instagram.com/..." name="instagram" value={astrologer_update_profile_form?.instagram} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Facebook Link</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="https://facebook.com/..." name="facebook" value={astrologer_update_profile_form?.facebook} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">LinkedIn Link</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="https://linkedin.com/in/..." name="linked_in" value={astrologer_update_profile_form?.linked_in} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">YouTube Link</label>
                                                                <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                    <input placeholder="https://youtube.com/c/..." name="youtube" value={astrologer_update_profile_form?.youtube} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <label className="block mb-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">Website Link</label>
                                                            <div className="border border-gray-200 rounded-xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                <input placeholder="https://..." name="website" value={astrologer_update_profile_form?.website} onChange={handle_change_astro_profile_update} className="w-full h-12 px-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" type="text" />
                                                            </div>
                                                        </div>

                                                        <h3 className="text-lg font-bold text-gray-800 tracking-tight pt-4 pb-2 border-b border-gray-100">About {user_role === 2 ? "Astrologer" : "Pandit"}</h3>
                                                        <div>
                                                            <div className="border border-gray-200 rounded-2xl overflow-hidden focus-within:border-[#9F2225] transition-all duration-200">
                                                                <textarea placeholder="Write something about yourself..." name="about_us" value={astrologer_update_profile_form?.about_us} onChange={handle_change_astro_profile_update} className="w-full min-h-[120px] p-4 text-sm text-gray-700 bg-gray-50/50 focus:ring-0 focus:outline-none font-medium" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-end gap-3 w-full mt-6 pt-4 border-t border-gray-100">
                                                        <button className="bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs font-bold py-2.5 px-6 rounded-xl transition-all duration-200" type="button" onClick={() => set_Astro_Active_Form("0")}>Prev</button>
                                                        <button className="bg-[#9F2225] hover:bg-[#851c1e] text-white text-xs font-bold py-2.5 px-6 rounded-xl shadow-sm transition-all duration-200" type="submit">Next</button>
                                                    </div>
                                                </form>
                                            </div>
                                        )}

                                        {/* STEP 2: GALLERY IMAGES */}
                                        {astro_step_active_form === "2" && (
                                            <div>
                                                <h3 className="text-lg font-bold text-gray-800 tracking-tight mb-5 pb-2 border-b border-gray-100">Gallery Upload</h3>
                                                <form method="post" onSubmit={handle_submit_Add_Gallery_details}>
                                                    <div className="space-y-4">

                                                        {/* Preview List */}
                                                        {profileImg?.length > 0 && (
                                                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 p-4 border border-gray-100 bg-gray-50/50 rounded-2xl">
                                                                {profileImg?.map((img, index) => (
                                                                    <div key={index} className="relative group rounded-xl border border-gray-200 shadow-sm bg-white p-1">
                                                                        <img
                                                                            src={img.url}
                                                                            alt={`preview-${index}`}
                                                                            className="w-full h-24 object-cover rounded-lg"
                                                                        />
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleRemoveImage(index)}
                                                                            className="absolute -top-1.5 -right-1.5 bg-red-600 hover:bg-red-700 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm shadow-sm transition-all duration-200"
                                                                        >
                                                                            &times;
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* Dashed Drag/Upload Dropzone */}
                                                        <div>
                                                            <button
                                                                type="button"
                                                                onClick={() => document.getElementById('pro-image').click()}
                                                                className="w-full flex flex-col items-center justify-center px-6 py-8 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-50 hover:bg-gray-100/80 transition-all duration-200 group cursor-pointer"
                                                            >
                                                                <svg className="w-10 h-10 text-gray-400 group-hover:text-[#9F2225] mb-2 transition-all duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"></path>
                                                                </svg>
                                                                <span className="text-sm font-bold text-gray-600 group-hover:text-gray-800 transition-all duration-200">+ Add Photos</span>
                                                                <span className="text-xs text-gray-400 mt-1">Upload multiple profile gallery images</span>
                                                            </button>
                                                            <input
                                                                type="file"
                                                                id="pro-image"
                                                                name="profileImg"
                                                                className="hidden"
                                                                multiple
                                                                onChange={handleImageChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-end gap-3 w-full mt-6 pt-4 border-t border-gray-100">
                                                        <button className="bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs font-bold py-2.5 px-6 rounded-xl transition-all duration-200" type="button" onClick={() => set_Astro_Active_Form("1")}>Prev</button>
                                                        <button className="bg-[#9F2225] hover:bg-[#851c1e] text-white text-xs font-bold py-2.5 px-6 rounded-xl shadow-sm transition-all duration-200" type="submit">Submit</button>
                                                    </div>
                                                </form>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )
            }

        </div>
    )
}

export default Astrologer_Save_Profile_Update